<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAbortableRequest } from 'dashboard/composables/useAbortableRequest';
import SingleSelect from 'dashboard/components-next/filter/inputs/SingleSelect.vue';
import AstraFlowsAPI from 'kanban/api/astraFlows';

defineProps({
  dropdownMaxHeight: { type: String, default: 'max-h-80' },
});
const model = defineModel({ type: Array, default: () => [] });
const { t } = useI18n();
const { accountId } = useAccount();
const { run, isPending } = useAbortableRequest();
const fluxos = ref([]);
const falha = ref(false);

const opcoes = computed(() =>
  fluxos.value
    .filter(
      flow => flow.is_active && ['chatbot', 'sequence'].includes(flow.flow_type)
    )
    .map(flow => ({ id: flow.id, name: flow.name }))
);
const selecionado = computed({
  get: () =>
    opcoes.value.find(flow => String(flow.id) === String(model.value[0])) || {},
  set: flow => {
    model.value = flow?.id ? [flow.id] : [];
  },
});

watch(
  accountId,
  async () => {
    fluxos.value = [];
    falha.value = false;
    try {
      const response = await run(signal => AstraFlowsAPI.get({ signal }));
      if (response) fluxos.value = response.data.data;
    } catch {
      falha.value = true;
    }
  },
  { immediate: true }
);
</script>

<template>
  <div class="flex flex-col gap-1 max-w-lg">
    <SingleSelect
      v-model="selecionado"
      :options="opcoes"
      :is-searching="isPending"
      :placeholder="t('AUTOMATION.ACTION.FLOW_SELECT')"
      :dropdown-max-height="dropdownMaxHeight"
    />
    <span v-if="falha" class="text-sm text-n-ruby-11">
      {{ t('AUTOMATION.ACTION.FLOW_LOAD_ERROR') }}
    </span>
    <span
      v-else-if="!isPending && !opcoes.length"
      class="text-sm text-n-slate-11"
    >
      {{ t('AUTOMATION.ACTION.FLOW_EMPTY') }}
    </span>
    <span class="text-xs text-n-slate-11">
      {{ t('AUTOMATION.ACTION.FLOW_ON_ENTRY_HINT') }}
    </span>
  </div>
</template>
